import React from 'react';
import TitleBanner from './TitleBanner';
import TestimonialSection from './TestimonialSection';
import TestimonialsSlider from './TestimonialsSlider';
import ApplicationForm from './ApplicationForm';

const InHomeSupport = () => {

    const features = [
        {
          title: "Medication Management",
          imageUrl: "LGA-InHome-MedicationManagement-Icon.svg"
        },
        {
          title: "Shopping",
          imageUrl: "LGA-InHome-Shopping-Icon.svg"
        },
        {
          title: "Transport",
          imageUrl: "LGA-InHome-Transport-Icon.svg"
        },
        {
            title: "Meal Preparation",
            imageUrl: "LGA-InHome-MealPreparation-Icon.svg"
          },
          {
            title: "Social Visits",
            imageUrl: "LGA-InHome-Social-Icon.svg"
          },
          {
            title: "Personal",
            imageUrl: "LGA-HomePage-TransitionandRespiteCare-Icon.svg"
          }
      ];


    return (
        <div>
            <TitleBanner image="/Website_Title_Images/In-Home_Support.svg" title={"In-Home Support"} subheading={"Find support tailored to your every need with LCA"} />
            <div className='flex justify-center items-center'>
            <div className="max-w-6xl px-4 sm:px-6 md:px-24 py-8 md:py-12">

              <h1 className="text-3xl md:text-4xl font-bold text-primary mb-4 md:mb-6" style={{ fontFamily: 'Arial Rounded MT Bold, Arial, sans-serif' }}>
                How can we support you?
              </h1>
              
              <div className="space-y-4 md:space-y-6">
                <p className="text-gray-800 text-base md:text-lg">
                  Livability Care Australia is committed to providing tailored in-home support services to enable individuals to receive the care they need in the comfort of their own homes.
                </p>
                
                <p className="text-gray-800 text-base md:text-lg">
                  Our qualified and trained staff work with each of our participants to actively support them in their daily living activities such as personal care, health care, mealtime assistance, money management and empower them to build relationships through increased community inclusion. We'll help you identify your goals and aspirations and put practical steps in place, so you achieve them.
                </p>
              </div>
            </div>
            </div>

            <div className="max-w-4xl mx-auto p-4 md:p-8">
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 md:gap-10 mb-8 md:mb-16">
                  {features.map((feature, index) => (
                    <div key={index} 
                      className="border-2 border-primary rounded-2xl p-4 md:p-8 text-center relative hover:shadow-lg transition-shadow"
                      style={{
                        transform: `rotate(${index % 2 === 0 ? '2' : '-4'}deg)`,
                        '@media (max-width: 640px)': {
                          transform: 'none'
                        }
                      }}>
                      <div className="mb-4 md:mb-6 rounded-full w-16 md:w-32 h-16 md:h-32 flex items-center justify-center mx-auto">
                        <img
                          src={"/Icons/"+feature.imageUrl}
                          alt={feature.title}
                          className="w-12 h-12 md:w-28 md:h-28"
                        />
                      </div>
                      <h3 className="font-bold text-primary mb-2 md:mb-3 text-lg md:text-xl">{feature.title}</h3>
                      <p className="text-base md:text-lg text-primary">{feature.description}</p>
                    </div>
                  ))}
                </div>
            </div>
            <ApplicationForm/>
            <TestimonialsSlider />
        </div>
    );
};

export default InHomeSupport;